import React from 'react';
import './SignatureInput.css';

interface SignatureInputProps {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    className?: string;
    disabled?: boolean;
}

const SignatureInput: React.FC<SignatureInputProps> = ({
    value,
    onChange,
    placeholder = 'Type your full name',
    className = '',
    disabled = false,
}) => {
    return (
        <div className={`signature-input-wrapper ${className}`}>
            <input
                type="text"
                value={value}
                onChange={(e) => onChange(e.target.value.replace(/[^a-zA-Z\s]/g, ''))}
                placeholder={placeholder}
                disabled={disabled}
                className="signature-raw-input"
                maxLength={100}
            />
            {value && (
                <div className="signature-preview">
                    <span className="signature-text">{value}</span>
                    <span className="signature-badge">✓ Signed</span>
                </div>
            )}
        </div>
    );
};

export default SignatureInput;
